import React from 'react';
import { 
  AppointmentContainer,
  AppointmentList,
  AppointmentItem,
  AppointmentTitle,
} from '../styles';

const Appointments = ({appointments}) => {
  return (
    <AppointmentContainer>
      <AppointmentTitle>Meus Agendamentos</AppointmentTitle>
      {appointments.length === 0 ? (
        <div>Você não tem agendamentos.</div>
      ) : (
        <AppointmentList>
          {appointments.map((appointment, index) => (
            <AppointmentItem key={index}>
              <div>
                <strong>Data:</strong> {appointment.date}
              </div>
              <div>
                <strong>Início:</strong> {appointment.start_time}
              </div>
              <div>
                <strong>Fim:</strong> {appointment.end_time}
              </div>
              <div>
                <strong>Tipo:</strong> {appointment.type === 'unique' ? 'Avulsa' : appointment.type === 'fixed' ? 'Mensal' : appointment.type}
              </div>
              {appointment.invitedUsers.length > 0 && (
                <div>
                  <strong>Convidado:</strong> {appointment.invitedUsers.join(', ')}
                </div>
              )}
              {appointment.status && (
                <div>
                  <strong>Status:</strong> {appointment.status}
                </div>
              )}
              {appointment.priorityExpiration && (
                <div>
                  <strong>Expiração da Prioridade:</strong> {appointment.priorityExpiration}
                </div>
              )}
            </AppointmentItem>
          ))}
        </AppointmentList>
      )}
    </AppointmentContainer>
  );
};

export default Appointments;
